import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const API_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

export default class OnlineStatusService {
  /**
   * Обновить online-статус пользователя
   * @param {boolean} isOnline — true (онлайн) или false (офлайн)
   * @returns {Promise<boolean>}
   */
  static async setOnlineStatus(isOnline) {
    try {
      if (typeof isOnline !== "boolean") {
        throw new Error("Аргумент isOnline должен быть boolean");
      }

      const user = await this.waitForAuthReady();
      if (!user) {
        throw new Error("Пользователь не авторизован");
      }

      const token = await user.getIdToken();

      const response = await axios.post(
        `${API_BASE_URL}/update_online_status`,
        { online: isOnline },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      console.log("📶 Online статус обновлён:", isOnline, response.data);
      return true;

    } catch (err) {
      console.error("❌ Ошибка обновления online статуса:", err);
      return false;
    }
  }

  /**
   * Дождаться авторизации пользователя
   * @returns {Promise<firebase.User|null>}
   */
  static waitForAuthReady() {
    return new Promise((resolve) => {
      const auth = getAuth();
      if (auth.currentUser) {
        resolve(auth.currentUser);
      } else {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          unsubscribe(); // отписка после получения пользователя
          resolve(user);
        });
      }
    });
  }
}